/**
 * Created by user on 2020/5/23.
 */

/**
 * 不轉換的共用字
 */
export const table_same = [
	// 不轉換的共用字
	'札',
	'污',
	'汙',
	'游',
	'遊',
	'伙',
	'夥',
	'御',
	'郁',
	'咔',
	'哢',
	'凌',
	'淩',
	'扎',
	'紮',
	'痴',
	'癡',
	//'咸',
	//'准',
	//'棲',
	//'栖',
	'嚯',
	//'余',
	'薑',
	'姜',
	'扡',
	'扦',
	'捻',
	'撚',
	'遝',
	'沓',
	//'淨',
	'栗',
	'挽',
	'灶',
	'竈',
	'霉',
	'黴',
	'欲',
	'慾',
	//'征',
	'讚',
	'菸',
	'拾',
	'十',
	'証',
	'捲',
	'卷',
	'燻',
	'熏',
	'吁',
	'籲',
	'龥',
	'蹠',
	'跖',
	'矽',
	'硅',
	'脩',
	'修',
	'犟',
	'剷',
	'噼',
	'劈',
	'擗',
	'核',
	'覈',
	'憷',
	'呼',
	'唿',
	'嗬',
	'呵',
	'脣',
	'唇',
	'唇',
	'升',
	'昇',
	'磐',
	'溪',
	'渓',
	'谿',
	'嵠',
	'祐',
	'佑',
	'媮',
	'偷',
	'瓮',
	'罋',
	'甕',
	'闇',
	'暗',
//	'佈',
//	'布',
	'痺',
	'痹',

	'雇',
	'僱',

	'秘',
	'祕',

	'周',
	'週',

	'闢',

	'簷',
	'檐',

	'涌',
	'湧',

	'家',
	'傢',

	'亘',
	'亙',

	'洩',
	'泄',

	'珮',
	'佩',

	'尅',

	'剿',
	'勦',

	'沉',
	'沈',

	'搾',
	'榨',

	'筱',
	'篠',

	'陞',

	'獃',

	'盃',

	'牋',

	'竝',

	'弔',

	'徬',
	'彷',

	'喦',
	'巖',
	'岩',

	'劄',

	'噪',
	'譟',

	'彫',
	'雕',

	'衊',
	'蔑',

	'蒙',
	'濛',
	'矇',
	'懞',

	'啣',

	'碹',

	'嫺',
	'鞦',
	'鬨',

	'譁',

	'箇',

	'勐',
	'猛',

	'熏',
	'薰',
	'燻',

	// https://github.com/bluelovers/ws-regexp/pull/3
	'暨',

];

export default table_same

